import React, { useState } from 'react';
import { Admin, defaultTheme, Resource, CustomRoutes } from 'react-admin';

import { getInfoValue, getGlobalData, setGlobalData } from './lib/globalData';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Alert
} from "@mui/material";

import { Route } from 'react-router-dom';
import dataProvider from './lib/dataProvider';
import authProvider from './lib/authProvider';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import germanMessages from 'ra-language-german';
import MyLayout from './lib/MyLayout';
import Login from './lib/Login.tsx';
import Dashboard from './routes/dashboard';
import Infoarchiv from './routes/infoarchiv';
import Ereignisarchiv from './routes/ereignisarchiv';
import ereignisedit from './routes/ereignisedit';

import englishMessages from 'ra-language-english';
import languageDe from './language-de';
import languageEn from './language-en';

import {MenuConext} from './lib/MenuContext';

import catchAll from './routes/catchAll'

import documents from './routes/rep/documents'
import repHistory from './routes/rep/history'
import repGuesthistory from './routes/rep/guesthistory'
import repMessages from './routes/rep/messages'
import repAutomail from './routes/rep/automail'
import repAutorep from './routes/rep/autorep'

import bwhsettings from './routes/bwh/settings'
import bwhagent from './routes/bwh/agent'
import bwhtext from './routes/bwh/text'
import bwhimage from './routes/bwh/image'
import bwhroomcategory from './routes/bwh/roomcategory'
import bwhservice from './routes/bwh/service'
import bwhguestfield from './routes/bwh/guestfield'
import discount from './routes/bwh/discount'

import sethostel from './routes/set/hostel'
import setbookingsheet from './routes/set/bookingsheet'
import setimage from './routes/set/image'
import rate from './routes/set/rate'
import payrequest from './routes/set/payrequest'
import paymenttype from './routes/set/paymenttype'
import setPayment from './routes/set/payment'
import setPaymentapp from './routes/set/paymentapp'
import agecategory from './routes/set/agecategory'
import setservice from './routes/set/service'
import guestcategory from './routes/set/guestcategory'
import guestdetail from './routes/set/guestdetail'
import prefcountry from './routes/set/prefcountry'
import specialday from './routes/set/specialday'
import room from './routes/set/room'
import bed from './routes/set/bed'
import roomcategory from './routes/set/roomcategory'
import setagentcontract from './routes/set/agentcontract'
import setagent from './routes/set/agent'
import setappopt from './routes/set/appopt'
import setpwdyubi from './routes/set/pwdyubi'
import setdbuser from './routes/set/dbuser'
import setroomcattext from './routes/set/roomcattext'
import setservicetext from './routes/set/servicetext'
import settkonfig from './routes/set/tkonfig'
import settkonfigspez from './routes/set/tkonfigspez'

import globuser from './routes/glob/user'
import globhostel from './routes/glob/hostel'
import globportalinfo from './routes/glob/portalinfo'
import globapp from './routes/glob/app'
import tlogapi from './routes/glob/tlogapi'

import calpricegr from './routes/cal/pricegr'
import calpreis from './routes/cal/preis'
import calpricegrcompare from './routes/cal/pricegrcompare'
import calpricecomparerate from './routes/cal/pricegrcomparerate'
import pricegrcomparevat from './routes/cal/pricegrcomparevat'
import calmwst from './routes/cal/mwst'
import calrate from './routes/cal/rate'
import calonline from './routes/cal/online'
import calonlinecompare from './routes/cal/onlinecompare'
import caloportal from './routes/cal/oportal'
import calservice from './routes/cal/service'


import AppDash from './routes/app/dash'
import Video from './routes/video'
import Contact from './routes/contact'
import Profil from './routes/profil';
import SetTransfer from './routes/set/transfer';
import YieldEdit from './routes/cal/yield'
import CalendarEdit from './routes/cal/calendar'
import ReportEdit from './routes/rep/report'
import BfsEdit from './routes/rep/bfs'
import GlobFindres from './routes/glob/findres'
import GlobServer from './routes/glob/server'
import RepBookingcom from './routes/rep/bookingcom'
import RepBookingsheet from './routes/rep/bookingsheet'
import RepStats from './routes/rep/stats'
import RepGdpr from './routes/rep/gdpr'
import RepGuestexport from './routes/rep/guestexport'
import SetAcquirer from './routes/set/acquirer'
import SetPricecomp from './routes/set/pricecomp'
import IfPortal from './routes/if/portal'
import IfList from './routes/if/list'
import ifportalhistory from './routes/if/portalhistory'
import BwhTranslation from './routes/bwh/translation'

import './App.css';

const App = () => {
  const [activeMain, setActivMain] = useState(-1);
  const [locked, setLocked] = useState(false);

  const updateMain = (newMain) => {
    setActivMain(newMain);
    localStorage.setItem('lastmenu', newMain);
  };

  const isExpired = () => {
    const expiry = getInfoValue('expiry');
    if (!expiry) return false;
    const now = new Date();
    const exp = new Date(expiry);
    //console.log(now, exp);
    if (!exp.getTime()) return false;
    return now >= exp;
  }

  const canSoftLock = () => {
    const dbId = parseInt(getInfoValue('db_id'), 10);
    const isChildToken = getInfoValue('back') === true;
    const parentExpiry = getInfoValue('parentexpiry');
    if (!isChildToken) return false;
    if (!dbId || dbId <= 0) return false;
    if (!parentExpiry) return false;
    const ret = new Date(parentExpiry) > new Date();
    if (ret === false) {
      setLocked(false);
      window.location.hash = '#/login';
    }
    return ret;
  }

  const LockLayer = ({open, unlock}) => {
    const [appuser, setAppUser] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

// im LockLayer:
    const onSubmit = async () => {
      setBusy(true);
      setError(null);
      try {
        const res = await dataProvider.update("authToken", {
          id: 0,
          data: { refresh:true, appuser, apppassword:password },
          previousData: {},
        });

        if (res.data.info) {
          const info = getGlobalData('info');
          setGlobalData({info: {...info, ...res.data.info}});
          localStorage.setItem('info', JSON.stringify({...info, ...res.data.info}));
          if (res.data.token) {
            setGlobalData({token: res.data.token});
            localStorage.setItem('token', res.data.token);
          }
        }
        if (res.data.menu) {
          setGlobalData({menu: res.data.menu});
          localStorage.setItem('menu', JSON.stringify(res.data.menu));
        }
        setPassword("");
        unlock();
      } catch (e) {
        setError(e?.message ?? "Refresh fehlgeschlagen");
      } finally {
        setBusy(false);
      }
    };

    const onHardLogout = () => {
      setLocked(false)
      window.location.href = "/#/login";
    };

    return (
      <Dialog open={open} fullWidth maxWidth="xs">
        <DialogTitle>Session locked</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField
            autoFocus
            fullWidth
            label="App-User"
            value={appuser}
            onChange={(e) => setAppUser(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") onSubmit(); }}
            sx={{ mt: 1, mb: 2 }}
          />
          <TextField
            fullWidth
            type="password"
            label="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") onSubmit(); }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onHardLogout} disabled={busy}>Log-Out</Button>
          <Button onClick={onSubmit} disabled={busy || !appuser} variant="contained">Unlock</Button>
        </DialogActions>
      </Dialog>
    );
  }

  // 1) Timer: ohne Interaktion prüfen/locken
  React.useEffect(() => {
    let t = null;

    const schedule = () => {
      if (window.location.hash!== '#/login' && isExpired()) {
        if (canSoftLock()) {
          setLocked(true);
        }
        else {
          setLocked(false);
          setGlobalData({token:false, info:false, menu:false});
          localStorage.removeItem('token');
          localStorage.removeItem('lastmenu');
          window.location.hash = '#/login';
        }
      }
    };
    const lock = () => {
      if (window.location.hash!== '#/login' && canSoftLock()) {
        setLocked(true);
      }
    };
    const hideLockOnLogin = () => {
      if (window.location.hash=== '#/login') {
        setLocked(false);
      }
    };
    window.addEventListener('bw-session-lock', lock);
    window.addEventListener('hashchange', hideLockOnLogin);
    t = window.setInterval(() => schedule(), 60 * 1000);
    hideLockOnLogin();
    schedule();
    return () => {
      window.removeEventListener('bw-session-lock', lock);
      window.removeEventListener('hashchange', hideLockOnLogin);
      window.clearInterval(t);
    };
  }, []);  

  const i18nProvider = polyglotI18nProvider(locale => {
    var texts = locale==='de'?{...languageEn, ...germanMessages, ...languageDe}:{...englishMessages,  ...languageEn};
    if (locale==='de') {
      texts.ra.notification.deleted = 'Element wird gelöscht |||| %{smart_count} Elemente werden gelöscht';
      texts.ra.action.select_columns = 'Spalten';
      texts.ra.configurable = {customize: 'Hallo'};
      texts.ra.sort = { ASC: '', DESC: ''}
    }
    else {
      texts.ra.notification.deleted = 'Deleting element |||| Deleting %{smart_count} elements';
      texts.ra.action.select_columns = 'Columns';
      texts.ra.sort.ASC = '';
      texts.ra.sort.DESC = '';
    }
    return texts;
  });

    
  const theme = {
      ...defaultTheme,
      palette: {
          primary: {
            main: '#3f51b5',
          }
      },
      components: {
          ...defaultTheme.components,
          // lastpass und browser-autocomplete aus allen eingabefeldern fernhalten;
          // login und neue passwoerter setzen eigene inputProps und bleiben damit fuer lastpass sichtbar
          MuiInputBase: {
              ...defaultTheme.components?.MuiInputBase,
              defaultProps: {
                  ...defaultTheme.components?.MuiInputBase?.defaultProps,
                  inputProps: { 'data-lpignore': 'true', autoComplete: 'off' },
              },
          },
      },
  };
  return (
    <MenuConext.Provider value={{activeMain, updateMain}}>
      <LockLayer open={locked} unlock={() => setLocked(false)} />
      <Admin
        i18nProvider={i18nProvider}
        catchAll={catchAll}
        authProvider={authProvider}
        layout={MyLayout}
        loginPage={Login}
        dataProvider={dataProvider}
        dashboard={Dashboard}
        theme={theme}
      >
        <Resource name="dashboardHomeinfo" {...ereignisedit} />

        <Resource name="repBookingcom" />
        <Resource name="repGdpr" />
        <Resource name="repDocuments" {...documents} />
        <Resource name="repGuestexport" />
        <Resource name="repMessages" {...repMessages} />
        <Resource name="repHistory" {...repHistory} />
        <Resource name="repGuesthistory" {...repGuesthistory} />
        <Resource name="repAutomail" {...repAutomail} />
        <Resource name="repAutorep" {...repAutorep} />

        <Resource name="bwhSettings" {...bwhsettings} />
        <Resource name="bwhAgent" {...bwhagent} />
        <Resource name="bwhDiscount" {...discount} />
        <Resource name="bwhText" {...bwhtext} />
        <Resource name="bwhTextagent"  />
        <Resource name="bwhImage" {...bwhimage} />
        <Resource name="bwhIcon" />
        <Resource name="bwhRoomcategory" {...bwhroomcategory} />
        <Resource name="bwhService" {...bwhservice} />
        <Resource name="bwhGuestfield" {...bwhguestfield} />

        <Resource name="setHostel" {...sethostel} />
        <Resource name="setBookingsheet" {...setbookingsheet} />
        <Resource name="setImage" {...setimage} />
        <Resource name="setCurrency" />
        <Resource name="setTimezone" />
        <Resource name="setRoomcattext" {...setroomcattext} />
        <Resource name="setServicetext" {...setservicetext} />
        <Resource name="setService" {...setservice} />
        <Resource name="setRoom" {...room} />
        <Resource name="setRoomcategory" {...roomcategory} />
        <Resource name="setBed" {...bed} />
        <Resource name="setAgentcontract" {...setagentcontract} />
        <Resource name="setAgent" {...setagent} />
        <Resource name="setAppopt" {...setappopt} />
        <Resource name="setSpecialday" {...specialday} />
        <Resource name="setAgecategory" {...agecategory} />
        <Resource name="setPrefcountry" {...prefcountry} />
        <Resource name="setPaymenttype" {...paymenttype} />
        <Resource name="setPayment" {...setPayment} />
        <Resource name="setPaymentapp" {...setPaymentapp} />
        <Resource name="setGuestcategory" {...guestcategory} />
        <Resource name="setGuestdetail" {...guestdetail} />
        <Resource name="setPwdyubi" {...setpwdyubi} />
        <Resource name="setDbuser" {...setdbuser} />
        <Resource name="setTkonfigspez" {...settkonfigspez} />
        <Resource name="setTkonfig" {...settkonfig} />
        <Resource name="setLoginlevel" />

        <Resource name="setRate" {...rate} />
        <Resource name="setPayrequest" {...payrequest} />
        <Resource name="setGuestfield" />
        <Resource name="setCondpayreq" />
        <Resource name="setCountry" />
        <Resource name="setSprache" />

        <Resource name="calYield" />
        <Resource name="calPricegr" {...calpricegr} />
        <Resource name="calPrice" edit={calpreis} />
        <Resource name="calPricegrcompare" {...calpricegrcompare} />
        <Resource name="calPricegrcomparerate" {...calpricecomparerate} />
        <Resource name="calPricegrcomparevat" {...pricegrcomparevat} />
        <Resource name="calMwst" {...calmwst} />
        <Resource name="calRate" {...calrate} /> 
        <Resource name="calOnline" {...calonline} />
        <Resource name="calOnlinecompare" {...calonlinecompare} />
        <Resource name="calOportal" {...caloportal} />
        <Resource name="calPortal" />
        <Resource name="calPortalroom" />
        <Resource name="calService" {...calservice} />

        <Resource name="globHostel" {...globhostel} />
        <Resource name="globServer" />
        <Resource name="setDbuserglob" {...setdbuser} />
        <Resource name="globUser" {...globuser}/>
        <Resource name="globPortalinfo" {...globportalinfo}/>
        <Resource name="globApp" {...globapp}/>
        <Resource name="globTlogapi" {...tlogapi}/>
        <Resource name="globUsergroup" />
        <Resource name="globConstant/preisplan" />
        <Resource name="globConstant/reseller" />
        <Resource name="globConstant/rabattart" />
        <Resource name="globConstant/credituse" />
        <Resource name="globConstant/alllifecycle" />
        <Resource name="ifAktionen" />
        <Resource name="IfList" />
        <Resource name="ifPortalhistory" {...ifportalhistory} />

        <CustomRoutes>
          <Route path="/appDash" element={<AppDash />} />,
          <Route path="/contact" element={<Contact />} />,
          <Route path="/infoarchiv" element={<Infoarchiv />} />,
          <Route path="/ereignisarchiv" element={<Ereignisarchiv />} />,
          <Route path="/video" element={<Video />} />,
          <Route path="/profil" element={<Profil />} />,
          <Route path="/setTransfer" element={<SetTransfer />} />,
          <Route path="/calYield" element={<YieldEdit />} />,
          <Route path="/calCalendar" element={<CalendarEdit />} />,
          <Route path="/repReport" element={<ReportEdit />} />,
          <Route path="/repBfs" element={<BfsEdit />} />,
          <Route path="/globFindres" element={<GlobFindres />} />,
          <Route path="/globServer" element={<GlobServer />} />,
          <Route path="/repBookingsheet" element={<RepBookingsheet />} />,
          <Route path="/repBookingcom" element={<RepBookingcom />} />,
          <Route path="/repStats" element={<RepStats />} />,
          <Route path="/repGdpr" element={<RepGdpr />} />,
          <Route path="/repGuestexport" element={<RepGuestexport />} />,
          <Route path="/setAcquirer" element={<SetAcquirer />} />,
          <Route path="/setPricecomp" element={<SetPricecomp />} />,
          <Route path="/ifList" element={<IfList />} />,

          <Route path="/ifPortal/*" element={<IfPortal />} />,
          <Route path="/bwhTranslation" element={<BwhTranslation />} />,
        </CustomRoutes>
      </Admin>
    </MenuConext.Provider>
  );
}
export default App;
